import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useCreateReleaseLabelGroup } from "@/queries";
import { displayToast } from "@/utils/toast";
import { ToastType } from "@/enums";

export const useReleaseLabelSubmission = (
  userToken: string,
  activeWorkspaceId: number,
  folder_id: number | null,
) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const { mutateAsync: createReleaseLabelGroup, isLoading: isLoadingPrompt } =
    useCreateReleaseLabelGroup(userToken);

  const isLoading = isLoadingPrompt || isSubmitting;

  const submitReleaseLabelSelection = (
    selectedReleaseLabel: string,
    onSubmit: (promptLabelName: string, type: "prompt") => void,
  ) => {
    onSubmit(selectedReleaseLabel, "prompt");
  };

  const submitExperimentCreation = async (
    selectedReleaseLabel: string,
    selectedRegistryIds: number[],
  ) => {
    setIsSubmitting(true);
    try {
      const response = await createReleaseLabelGroup({
        prompt_label_name: selectedReleaseLabel,
        prompt_registry_ids: selectedRegistryIds,
        workspace_id: activeWorkspaceId,
        folder_id,
      });

      if (response.success) {
        displayToast("A/B release created!", ToastType.success);

        navigate(
          `/workspace/${activeWorkspaceId}/ab-releases/prompt-release-group/${response.release_label_group?.id}`,
        );
        return { success: true };
      }
      throw new Error(response.error || "Error creating A/B release");
    } catch (error) {
      if (error instanceof Error) {
        throw error;
      }
      throw new Error("Network error or bad server response");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    isLoading,
    submitReleaseLabelSelection,
    submitExperimentCreation,
  };
};
